module.exports = __webpack_public_path__ + "static/media/installation3.07014248.jpg";